"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _Shop = require("./Shop");
var Profile = /*#__PURE__*/function () {
  function Profile(json) {
    (0, _classCallCheck2["default"])(this, Profile);
    this.userID = null;
    this.userName = null;
    this.userData = null;
    this.userPhone = null;
    this.userLang = null;
    this.userImg = null;
    this.group = null;
    this.admin = false;
    this.guest = false;
    this.shopadmin = false;
    this.shop = null;
    this.shops = [];
    this.brands = [];
    this.countries = [];
    this.moduli = null;
    this.cats = [];
    this.cli = null;
    this.cli2 = null;
    this.interno = null;
    this.grpdata = null;
    this.seller = null;
    this.sellerdes = null;
    this.extra = null;
    this.guestguid = null;
    this.guestemail = null;
    this.catalog = null;
    this.gdprFlags = null;
    this.firstname = null;
    this.lastname = null;
    this.censoredlastname = null;
    this.userID = json.userID || null;
    this.userName = json.userName || null;
    this.userData = json.userData || null;
    this.userPhone = json.userPhone || null;
    this.userLang = json.userLang || null;
    this.userImg = json.userImg || null;
    this.group = json.group || null;
    this.admin = !!json.admin || false;
    this.guest = !!json.guest || false;
    this.shopadmin = !!json.shopadmin || false;
    this.shop = new _Shop.Shop(json.shop) || null;
    this.moduli = json.moduli || null;
    this.cats = json.cats || [];
    this.cli = json.cli || null;
    this.cli2 = json.cli2 || null;
    this.interno = json.interno || null;
    this.grpdata = json.grpdata || null;
    this.seller = json.seller || null;
    this.sellerdes = json.sellerdes || null;
    this.extra = json.extra || null;
    this.guestguid = json.guestguid || null;
    this.guestemail = json.guestemail || null;
    this.firstname = json.firstname || null;
    this.lastname = json.lastname || null;
    this.censoredlastname = json.censoredlastname || null;
    this.countries = json.enabledContries || [];
    this.brands = json.enabledBrands || [];
    this.gdprFlags = json.GDPR_Flags;
    this.setShops(json.shops);
  }
  (0, _createClass2["default"])(Profile, [{
    key: "setShops",
    value: function setShops(shops) {
      if (shops && shops.length > 0) {
        this.shops = [];
        for (var i = 0; i < shops.length; i++) this.shops.push(new _Shop.Shop(shops[i]));
      }
    }
  }, {
    key: "setCatalog",
    value: function setCatalog(catalog) {
      var _context;
      var find = !!(0, _find["default"])(_context = this.cats).call(_context, function (c) {
        return c.cod === catalog;
      });
      if (!find) console.warn('User not allowed to use catalog ' + catalog);
      this.catalog = catalog;
    }
  }]);
  return Profile;
}();
exports.Profile = Profile;
//# sourceMappingURL=Profile.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Profile.js
// module id = 1264
// module chunks = 142